const doughnut = (data) => {
    const defaultConfig = {
        tooltip: {
            trigger: 'item'
          },
          legend: {
            type: 'scroll',
            top: '1%',
            // left: 'center'
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              padAngle: 5,
              itemStyle: {
                borderRadius: 10
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: data
            }
          ]
        }
        const opt = Object.assign({}, defaultConfig)
  
  return opt
    }
    export default doughnut